import Vue from 'vue'
import WebCam from "vue-web-cam"

Vue.use(WebCam)
